module.exports = __webpack_public_path__ + "static/media/search-black.9d8c09c4.svg";